import React, { useState, useEffect } from "react";
import Navbar from "../components/Navbar";
import Footer from "../pages/main/footer";
import "./CancellationPolicy.css";
import api from "../services/httpService";

const CancellationPolicy = () => {
  const [policy, setPolicy] = useState(null);
  const [loading, setLoading] = useState(true);
  // const [themeColors, setThemeColors] = useState({
  //   color1: "#f83600",
  //   color2: "#fe8c00"
  // });

  useEffect(() => {
    fetchPolicy();
    fetchThemeColors();
  }, []);

  const fetchThemeColors = async () => {
    try {
      const res = await api.get("/sentinix/dashboardsettings");
      if (res.data.success && res.data.data) {
        const allData = Array.isArray(res.data.data) ? res.data.data : [res.data.data];
        const latest = allData.sort((a, b) => b.id - a.id)[0];

        if (latest) {
          const color1 = latest.color1 || "#f83600";
          const color2 = latest.color2 || "#fe8c00";
          
          //setThemeColors({ color1, color2 });
          
          // Apply to CSS variables
          document.documentElement.style.setProperty("--theme-color1", color1);
          document.documentElement.style.setProperty("--theme-color2", color2);
        }
      }
    } catch (err) {
      console.error("Error fetching theme colors:", err);
    }
  };

  const fetchPolicy = async () => {
    try {
      const res = await api.get("/sentinix/cancelationpolicy");
      if (res.data.success && res.data.data) {
        const data = Array.isArray(res.data.data)
          ? res.data.data.filter(d => !d.isDeleted).sort((a, b) => b.id - a.id)[0]
          : res.data.data;
        setPolicy(data || null);
      }
    } catch (err) {
      console.error("Error fetching cancellation policy:", err);
    } finally {
      setLoading(false);
    }
  };

  const renderContent = (text) => {
    if (!text) return <p className="cp-empty">No content available.</p>;
    return text.split("\n").map((line, idx) => {
      const trimmed = line.trim();
      if (!trimmed) return <br key={idx} />;
      const isSubHeading = /^\d+\.\d+/.test(trimmed);
      const isHeading    = /^\d+\./.test(trimmed);
      const isBullet     = trimmed.startsWith("•") || trimmed.startsWith("-");
      if (isSubHeading)  return <h4 key={idx} className="cp-subheading">{trimmed}</h4>;
      if (isHeading)     return <h3 key={idx} className="cp-heading">{trimmed}</h3>;
      if (isBullet)      return (
        <div key={idx} className="cp-bullet">
          <span className="cp-bullet-dot">•</span>
          <span>{trimmed.replace(/^[•-]\s*/, "")}</span>
        </div>
      );
      return <p key={idx} className="cp-paragraph">{trimmed}</p>;
    });
  };

  if (loading) {
    return (
      <>
        <Navbar />
        <div className="cp-loading-container">
          <div className="cp-loading-hero" />
          <div className="cp-loading-content">
            <div className="cp-loading-title" />
            {[1,2,3,4,5].map(i => <div key={i} className="cp-loading-line" />)}
          </div>
        </div>
        <Footer />
      </>
    );
  }

  return (
    <>
      <Navbar />
      <div className="cp-container">

        {/* ===== HERO ===== */}
        <div className="svc-hero">
          {policy?.ImageKey ? (
            <img src={policy.ImageKey} alt="Banner" className="svc-hero-img"
              onError={(e) => { e.target.style.display = "none"; }} />
          ) : (
            <div className="cp-hero-placeholder" />
          )}
          <div className="cp-hero-overlay">
            {/* <h1 className="cp-hero-title">
              {policy?.title || "Cancellation & Refund Policy"}
            </h1> */}
            <div className="cp-hero-divider" />
            <p className="cp-hero-subtitle">
              Last updated on {policy?.createdAt ? new Date(policy.createdAt).toLocaleDateString() : "Oct 3 2025"}
            </p>
          </div>
        </div>

        {/* ===== CONTENT CARD ===== */}
        <div className="cp-main">
          <div className="cp-card">

            {/* Card Header */}
            <div className="cp-card-header">
              <div className="cp-card-icon">📋</div>
              <div>
                <h2 className="cp-card-title">
                  {policy?.title || "Cancellation & Refund Policy"}
                </h2>
              </div>
            </div>

            <div className="cp-divider" />

            {/* Content */}
            <div className="cp-content">
              {renderContent(policy?.description)}
            </div>

            <div className="cp-divider" />

          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default CancellationPolicy;